module.exports = __webpack_public_path__ + "static/media/5.00f21c06.jpg";